import React from 'react';
interface FlowLineProps {
  className?: string;
  color?: string;
  animated?: boolean;
  width?: number;
}
const FlowLine = ({
  className = '',
  color = '#7091E6',
  animated = true,
  width = 3
}: FlowLineProps) => {
  return <div className={`absolute opacity-30 ${className}`} data-id="element-543">
      <svg width="100%" height="100%" viewBox="0 0 1000 100" preserveAspectRatio="none" data-id="element-544">
        <path d="M0,50 C200,20 300,80 500,50 C700,20 800,80 1000,50" stroke={color} strokeWidth={width} fill="none" className={animated ? 'animate-pulse' : ''} strokeDasharray={animated ? '5,5' : '0'} strokeLinecap="round" data-id="element-545" />
      </svg>
    </div>;
};
export default FlowLine;